import { useContext, useMemo } from 'react'
import { UserSessionResponse } from '../interfaces'
import { PublicLinksInfo } from '../interfaces/PublicLinks'
import { PublicLinksInfoContext } from '../providers/PublicLinksInfoProvider'

const useGetFileUrlArguments = ({
  user,
  clientInfo,
}: {
  user: UserSessionResponse | null
  clientInfo: PublicLinksInfo["clientInfo"]
}): {
  imagekitId: string
  firstCustomCname?: UserSessionResponse["firstCustomCname"],
  onlySignedGet?: UserSessionResponse["onlySignedGet"],
  onlyNamedGet?: UserSessionResponse["onlyNamedGet"],
  onlySignedVideoGet?: UserSessionResponse["onlySignedVideoGet"],
  onlyNamedVideoGet?: UserSessionResponse["onlyNamedVideoGet"],
  urlPrefix: string
} => {
  const { urlPrefix } = useContext(PublicLinksInfoContext)
  const getFileUrlDynamicArguments = useMemo<{
    imagekitId: string
    firstCustomCname?: UserSessionResponse["firstCustomCname"],
    onlySignedGet?: UserSessionResponse["onlySignedGet"],
    onlyNamedGet?: UserSessionResponse["onlyNamedGet"],
    onlySignedVideoGet?: UserSessionResponse["onlySignedVideoGet"],
    onlyNamedVideoGet?: UserSessionResponse["onlyNamedVideoGet"],
    urlPrefix: string
  }>(() => {
    let dynamicArguments

    if (typeof clientInfo !== "undefined") {
      dynamicArguments = {
        imagekitId: clientInfo.imagekitId,
        firstCustomCname: clientInfo.firstCustomCname,
        onlySignedGet: clientInfo.settings.onlySignedGet,
        onlyNamedGet: clientInfo.settings.onlyNamedGet,
        onlySignedVideoGet: clientInfo.settings.onlySignedVideoGet,
        onlyNamedVideoGet: clientInfo.settings.onlyNamedVideoGet,
        urlPrefix,
      }
    } else {
      dynamicArguments = {
        imagekitId: user?.imagekitId ?? "",
        firstCustomCname: user?.firstCustomCname,
        onlySignedGet: user?.onlySignedGet,
        onlyNamedGet: user?.onlyNamedGet,
        onlySignedVideoGet: user?.onlySignedVideoGet,
        onlyNamedVideoGet: user?.onlyNamedVideoGet,
        urlPrefix,
      }
    }

    return dynamicArguments
  }, [clientInfo, user])

  return getFileUrlDynamicArguments
}

export default useGetFileUrlArguments
